import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '@/store/configureStore';
import { logout } from '@/store/slices/account';
import { ROUTES } from '@/constants';

const IDLE_TIMEOUT_MS = 15 * 60 * 1000;
const ACTIVITY_EVENTS = ['mousemove', 'mousedown', 'keydown', 'wheel', 'touchstart'];

// Logs the user out after IDLE_TIMEOUT_MS of no mouse/keyboard/touch
// activity. Mirrors the manual logout in components/header/index.tsx
// (dispatch(logout()) + a full navigation to the login page, rather than
// history.push, so app state resets cleanly).
export const useIdleTimeout = (enabled: boolean) => {
  const dispatch = useDispatch<AppDispatch>();
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const handleTimeout = () => {
      dispatch(logout());
      window.location.href = ROUTES.LOGIN;
    };

    const resetTimer = () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(handleTimeout, IDLE_TIMEOUT_MS);
    };

    resetTimer();
    ACTIVITY_EVENTS.forEach((event) => window.addEventListener(event, resetTimer));

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      ACTIVITY_EVENTS.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, [enabled, dispatch]);
};
